import React, { useEffect } from 'react';
import { useProfileStore } from '../../state/profileStore';
import { useParams, useNavigate } from 'react-router-dom';
import UserProfile from './userprofile';

function NewUserProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = useProfileStore((s) => s.profile);

  useEffect(() => {
    // If user has first and last name, redirect to named profile
    if (user && user.u_first_name && user.u_last_name) {
      const slug = `${user.u_first_name.toLowerCase()}_${user.u_last_name.toLowerCase()}`;
      navigate(`/profile/${slug}`, { replace: true });
    }
  }, [user, navigate]);

  // If no user data or ID doesn't match, show loading
  if (!user || user.u_id !== parseInt(id)) {
    return <div className="container mx-auto w-4/5 p-6">Loading profile...</div>;
  }

  // Render the regular UserProfile component
  return <UserProfile />;
}

export default NewUserProfile;